import {
  createSlice,
  createEntityAdapter,
  createSelector,
} from '@reduxjs/toolkit';
import { UNKNOWN } from '../../constant/variables';

const reportsAdapter = createEntityAdapter({
  selectId: (report) => report.uid,
});

const initialState = reportsAdapter.getInitialState({
  status: UNKNOWN,
});

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    reportsStatus(state, action) {
      state.status = action.payload;
    },
    reportsAddMany: reportsAdapter.addMany,
    reportsAddOne: reportsAdapter.addOne,
    reportsSetAll: reportsAdapter.setAll,
  },
});

export const { reportsAddMany, reportsAddOne, reportsStatus, reportsSetAll } =
  reportsSlice.actions;

export default reportsSlice.reducer;

export const { selectAll: selectReports, selectById: selectReportById } =
  reportsAdapter.getSelectors((state) => state.reports);

export const selectReportsIds = createSelector(selectReports, (reports) =>
  reports.map((report) => report.uid)
);

export const selectReportsByBusinessId = createSelector(
  // All Transactions
  selectReports,

  // BusinessId
  (_, businessId) => businessId,

  (reports, businessId) =>
    reports.filter((report) => report.businessId === businessId)
);
